import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DataTransferServiceService {

  constructor(private http: HttpClient, private router: Router) { }


  getAllDataByCategory(param: any) {
    return this.http.get(`${environment.apiBaseUrl}/webEbook/category`, {
      params: {
        caTitle: param.caTitle,
        caType: param.caType

      }
    });
  }

  getBookById(id: any) {
    return this.http.get(`${environment.apiBaseUrl}/ebook-content/byEbook/${id}`,);
  }

  getAllVideos() {
    return this.http.get(`${environment.apiBaseUrl}/videos/getAllVideosByCategoryId`);
  }

  getVideoByCategoryName(param: any) {
    return this.http.get(`${environment.apiBaseUrl}/videos/subcategory`, {
      params: {
        subCategoryName: param.subCategoryName
      }
    });
  }

  getVideoByCategoryId(id: any) {
    return this.http.get(`${environment.apiBaseUrl}/videos/getCategoryById/${id}`,);
  }

  getVideoById(id: any) {
    return this.http.get(`${environment.apiBaseUrl}/videos/${id}`);
  }

  logPageVisitByIp(url: any) {
    const postData={
     plUrl:url
    }
    return this.http.post(`${environment.apiBaseUrl}/page-logs/record`, postData);
  }


  // checkIp(): void {
  //   this.http.get('https://api.ipify.org?format=json').subscribe({
  //     next: (res: any) => {
  //       const ip = res.ip;
  //       console.log("ip",ip);
        
  //       this.http.get(`${environment.apiBaseUrl}/page-logs/byIp`, {
  //         params: { ip }
  //       }).subscribe({
  //         next: (logRes) => {
  //         },
  //         error: (err) => {
  //           console.error('Failed to log page visit:', err);
  //         }
  //       });
  //     },
  //     error: (err) => {
  //       console.error('Failed to get public IP:', err);
  //     }
  //   });
  // }

}
